import { UI_STYLES } from "@/styles/uiStyles";

interface ZodiacPrognosisModalContentProps {
  setIsDescriptionOpen: (isOpen: boolean) => void;
}

export const ZodiacPrognosisModalContent = ({
  setIsDescriptionOpen,
}: ZodiacPrognosisModalContentProps) => {
  return (
    <div className="flex flex-col items-center justify-center w-full ">
      <div className=" text-white text-sm leading-relaxed p-4 text-center mb-6 hide-scrollbar max-h-[300px] overflow-y-auto">
        В данном разделе вы получаете общий Зодиакальный прогноз относительно
        представителей вашего знака и он представляет из себя усредненный
        вектор, который задает «характер недели». И который объясняет, для каких
        дел эта неделя лучше всего подходит, а какие лучше отложить на потом.
        Такой усредненный "прогноз астрологической погоды" действительно
        подходит для всех. Ведь он подобно компасу, обозначает общие тенденции,
        указывает наилучшее направление, а также предупреждает, в какую сторону
        идти не стоит. Ну, а вы уже, как в случае с компасом или навигатором,
        сами вольны выбирать свой маршрут.<br></br>
        <br></br> Индивидуальный же прогноз составляется под конкретного
        человека, в этом случае надо знать не только дату рождения, но время и
        место рождения. Такой прогноз может предсказать конкретные события в
        вашей жизни, и ответит на те вопросы, которые вы зададите. С такой
        услугой вы сможете обратиться ко мне на индивидуальной консультации или
        вытянув Счастливую карту и в качестве бонуса получите скидку в 10% на
        следующий прогноз.<br></br>С уважением, ваш астролог Татьяна Данченкова!
      </div>
      <button
        className={`w-full max-w-xs ${UI_STYLES.buttonGradient} hover:bg-cyan-700 text-white  rounded-xl py-3 mb-2 transition`}
        onClick={() => setIsDescriptionOpen(false)}
      >
        Понятно
      </button>
    </div>
  );
};
